import React from "react";
import { Card } from "@chakra-ui/react";
import "../../Animations.css";
import {
  getCardBaseStyles,
  getCardLayoutStyles,
  getCardContentStyles,
} from "../../styles/cardStyles";
import { haptic } from "@/lib/haptic";

interface OnboardingCardProps {
  emoji: string;
  title: string;
  disabled?: boolean;
  learnerCount?: string;
  selected?: boolean;
  subtitle?: string;
  onClick?: () => void;
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({
  emoji,
  title,
  disabled = false,
  learnerCount,
  selected = false,
  subtitle = "",
  onClick,
}) => {
  const baseStyles = getCardBaseStyles(selected, false, disabled);
  const layoutStyles = getCardLayoutStyles("onboarding");
  const contentStyles = getCardContentStyles("centered");

  const handleClick = () => {
    haptic.soft();
    onClick?.();
  };

  return (
    <Card
      direction={"column"}
      justifyContent={"center"}
      {...layoutStyles}
      {...baseStyles}
      onClick={handleClick}
      className={`${baseStyles.className} ${contentStyles.className} ${
        selected ? "press-animation" : ""
      }`}
    >
      <div className="text-4xl mb-2">{emoji}</div>
      <div className={`font-semibold text-base mb-1`}>{title}</div>
      <div
        className={`text-xs ${
          disabled ? "italic" : "text-[var(--color-grey)]"
        }`}
      >
        {disabled
          ? "Coming soon"
          : subtitle
          ? subtitle
          : learnerCount
          ? `${learnerCount} learners worldwide`
          : ""}
      </div>
    </Card>
  );
};

export default OnboardingCard;
